//import Edit from "../../../../../icons/EditIcon.svg";
//import Edit_gray from "../../../../../icons/Edit_gray.svg";
import {ICONS} from "../../../common/constants/icons";
//import Delete from "../../../../../icons/DeleteIcon.svg";
//import Export from "../../../../../icons/Download_Blue_Big.svg";
//import Export_gray from "../../../../../icons/Download_Grey_Big.svg";
//import copy from "../../../../../icons/copy.svg";
import Close from "../../../../../icons/Close.svg";
import PDF_Icon from "../../../../../icons/PDF.svg";
import XLS_Icon from "../../../../../icons/XLS.svg";

export default (props) => {
  const { actions = [] } = props;
  return (
    <div className="cell-action">
      {actions.includes('cancel') && (
        <img
          onMouseOver={(e) => (e.currentTarget.src = Close)}
          onMouseOut={(e) => (e.currentTarget.src = Close)}
          src={Close}
          alt="cancel"
          style={{ position: "relative", bottom: "8px" }}
          onClick={() => props.handleCancelEvent(props.selectedData)}
        />
      )}
      {actions.includes('delete') && (
        <img
          src={ICONS.DeleteGray}
          onMouseOver={(e) => (e.currentTarget.src = ICONS.Delete)}
          onMouseOut={(e) => (e.currentTarget.src = ICONS.DeleteGray)}
          alt="delete"
          className="p-1"
          style={{ position: "relative", bottom: "8px" }}
          onClick={() => props.handleDeleteEvent(props.selectedData)}
        />
      )}
      {actions.includes('edit') && (
        <img
          onMouseOver={(e) => (e.currentTarget.src = ICONS.Edit)}
          onMouseOut={(e) => (e.currentTarget.src = ICONS.Edit_gray)}
          src={ICONS.Edit_gray}
          alt="edit"
          style={{ position: "relative", bottom: "8px" }}
          onClick={() => props.handleEditEvent(props.selectedData)}
        />
      )}
      {actions.includes('export') && (
        <img
          src={PDF_Icon}
          alt="PDF Export"
          style={{ position: "relative", bottom: "8px" }}
          onClick={() => props.handlePdfEvent(props.selectedData)}
        />
      )}
      {actions.includes('copy') && (
        <img
          src={ICONS.Copy}
          alt="copy"
          style={{ position: "relative", bottom: "8px" }}
          onClick={() => props.handleCopyEvent(props.selectedData)}
        />
      )}
      {actions.includes('excel') && (
        <img
          src={XLS_Icon}
          alt="Excel Export"
          style={{ position: "relative", bottom: "8px" }}
          onClick={() => props.handleExcelEvent(props.selectedData)}
        />
      )}
    </div>
  );
};